$( function() {
	var $content = $( '#content' );

	$( 'body#professional-development-home' ).each( function() {
		var i;

		$( '#slideshow' ).jeSlideshow();

		if( $( 'html' ).data( 'site' ) === 'AUS-NZ' ) {
			return;
		}

		for( i = -1; i < 6; i++ ) {
			$( '#panels > li' ).eq( Math.max( 0, Math.min( i, 4 ) ) ).append( $.create( 'div' ).addClass( 'shadow' ).addClass( 'shadow-' + ( i + 2 ) ) );
			$( '#panels-rollover-off > li' ).eq( Math.max( 0, Math.min( i, 4 ) ) ).append( $.create( 'div' ).addClass( 'shadow' ).addClass( 'shadow-' + ( i + 2 ) ) );
		}

		var riseDuration = 500;
		var riseLow = 301;
		var riseHighOffset = 149;

		$( '#panels > li' )
		.mouseover( function( e ) {
			var $t = $( this );

			var riseHigh = $t.parent().height() - ( riseHighOffset + $t.height() );

			$t
			.stop( false )
			.animate( { top: riseHigh + 'px' }, riseDuration, 'easeOutBack' );
		} )
		.mouseleave( function( e ) {
			var $t = $( this );

			$t
			.stop( false )
			.animate( { top: riseLow + 'px' }, riseDuration, 'easeInOutCubic' );
		} )
		.each( function() {
			var $t = $( this );
			$t.css( { top: riseLow + 'px' } );
		} );
	} );

	$content.addClass( 'supports-png' );
	$content.addClass( 'supports-dynamic-png' );

	//setup tabs for interior pages
	$( '.pagemode-normal ul.dyna-pages, .pagemode-preview ul.dyna-pages  ' )
	.each( function( index, e ) {
		var $e = $( e );
		var id = 'dyna-pages-' + index;
		if( !$e.attr( 'id' ) ) {
			$e.attr( 'id', id );
		} else {
			id = $e.attr( 'id' );
		}
		//create wrapper for ul
		$e.wrap( '<div id="wrapper-' + id + '" class="dyna-pages-wrapper"/>' );

		$( '#wrapper-' + id ).prepend( $( '<ul id="navigation-' + id + '">' ).addClass( 'dyna-pages-navigation' ) );
		// add tabs to navigation ul
		$e.children( 'li' ).each( function( i, el ) {

			var $el = $( el );
			$el.attr( 'id', 'dyna-page-' + id + '-' + i )
			.addClass( 'dyna-page dyna-page-' + i );
			var txt = $el.children( '.tab-name' ).text();
			var li = $( '<li id="navigation-element-' + id + '-' + i + '"/>' )
			.addClass( 'navigation-element navigation-element-' + i )
			.data( 'navigation-index', i )
			.data( 'parent-id', id );

			//add a way to get to the pages via ID
			var a = $( '<a href="#' + li.attr( 'id' ) + '"/>' )
			.text( txt )
			.click( function() {
				var state = {};
				var id = $( this ).closest( '.dyna-pages-navigation' ).attr( 'id' );
				var href = $( this ).attr( 'href' );
				var url = href.substring( href.indexOf( '#' ) + 1 );

				//Tracking tab click
				require( ['analytics'], function( analytics ) {
					analytics.trackPageview( window.location.pathname + href );
				} );

				state[id] = url;
				$.bbq.pushState( state );

				return false;
			} );

			li.append( a );

			$( '#navigation-' + id ).append( li );

		} );
	} );

	//create expandable list
	$( '.pagemode-normal .expand-list, .pagemode-preview .expand-list' ).each( function( index, e ) {
		var $e = $( e );
		var id = 'expand-list-' + index;
		//make sure list has an ID
		if( !$e.attr( 'id' ) ) {
			$e.attr( 'id', id );
		} else {
			id = $e.attr( 'id' );
		}

		//find all expand list items 
		$e.children( 'li' ).each( function( i, el ) {
			var $el = $( el );
			$el.attr( 'id', 'expand-list-' + id + '-' + i )
			.addClass( 'expand-list-item expand-list-item-' + i )
			.data( 'parent-id', id );

			var $tabname = $el.children( '.expand-header' ).children( '.expand-name' );
			var txt = $tabname.text();
			$tabname.text( '' );

			//add a way to get to the pages via ID
			var a = $( '<a href="#' + $el.attr( 'id' ) + '"/>' )
			.text( txt )
			.click( function() {
				var state = {};
				var id = $( this ).closest( '.expand-list' ).attr( 'id' );
				var href = $( this ).attr( 'href' );
				var url = href.substring( href.indexOf( '#' ) + 1 );

				state[id] = url;
				$.bbq.pushState( state );
				return false;
			} );

			$tabname.append( a );
		} );
	} );

	$( '.navigation-element-0, .dyna-page-0, .expand-list-item-0' ).addClass( 'selected' );


	//when the hash changes find the element it refers to and mark it selected
	$( window ).bind( 'hashchange', function( e ) {
		var idx = $.bbq.getState();

		$( '.dyna-pages-navigation, .expand-list' ).each( function( index, e ) {
			var $e = $( e );
			var navId = idx[$e.attr( 'id' )];
			if( navId !== undefined ) {
				//Hey Listen!
				var $navE = $( '#' + navId );
				var $pagesparent = $( '#' + $navE.data( 'parent-id' ) );
				var $navparent = $( '#navigation-' + $navE.data( 'parent-id' ) );

				if( $e.hasClass( 'expand-list' ) ) {
					$e.children( '.expand-list-item.selected' ).removeClass( 'selected' );
				}

				$navparent.children( '.navigation-element.selected' ).removeClass( 'selected' );
				$pagesparent.children( '.dyna-page.selected' ).removeClass( 'selected' );
				$navE.addClass( 'selected' );
				$pagesparent.children( '.dyna-page-' + $navE.data( 'navigation-index' ) ).addClass( 'selected' );
			}
		} );

	} );
	$( window ).trigger( 'hashchange' );
} );